import { BlogDataService } from 'src/app/data/repository/blog-repository/blog-data.service';
import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { Subscription } from 'rxjs';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { BlogShared } from './../../general/shared/blog-shared';
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { SetUsernameBottomsheetComponent } from '../set-username-bottomsheet/set-username-bottomsheet.component';

@Component({
  selector: 'app-blog-suggest',
  templateUrl: './blog-suggest.component.html',
  styleUrls: ['./blog-suggest.component.scss'],
})
export class BlogSuggestComponent implements OnInit, OnDestroy {
  private _input: BlogUserModel[];
  @Input() set input(value: BlogUserModel[]) {
    this._input = value;
  }
  get input(): BlogUserModel[] {
    return this._input;
  }
  @Input() user: BlogUserModel;

  subscription1: Subscription;

  constructor(
    public blogShared: BlogShared,
    private blogService: BlogService,
    private matBottomSheet: MatBottomSheet,
    private snackBarService: SnackBarService,
    private blogDataService: BlogDataService
  ) {
    this.subscription1 = this.blogShared.usernameChangeObs$.subscribe(
      (changed) => {
        if (changed) {
          this.user.userName = this.blogShared.newUsername;
        }
      }
    );
    this.input = this.blogDataService.getSuggest();
    this.user = this.blogDataService.getUser();
    if (!this.input || !this.user) {
      this.blogService.goback();
    }
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
  }

  openProfile(username: string) {
    // this.blogShared.blogOpenProfile(username);
    this.blogService.goToUserProfile(username);
  }
  closeSuggest() {
    this.blogService.goback();
  }
  follow(user: BlogUserModel) {
    if (this.checkUsername()) {
      this.blogService.follow(user.id).then((res) => {
        if (res.isSuccess()) {
          if (user.status === 'private') {
            this.blogShared.pendingSuggestedUsernames.push(user.userName);
          } else {
            this.blogShared.followedSuggestedUsernames.push(user.userName);
          }
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
      });
    }
  }

  unFollow(user: BlogUserModel) {
    this.blogService.follow(user.id).then((res) => {
      if (res.isSuccess()) {
        this.blogShared.followedSuggestedUsernames.splice(
          this.blogShared.followedSuggestedUsernames.indexOf(user.userName),
          1
        );
        this.blogShared.pendingSuggestedUsernames.splice(
          this.blogShared.pendingSuggestedUsernames.indexOf(user.userName),
          1
        );
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }

  checkUsername(): boolean {
    if (this.user.userName === '') {
      this.matBottomSheet.open(SetUsernameBottomsheetComponent, {
        panelClass: 'custom-bottomsheet-container',
      });
      return false;
    }
    return true;
  }
}
